import React from "react";
import { node, string } from "prop-types";

import { useStore } from "../../utilities/mobx/storeHooks";
import * as S from "./styled";

const ValuationContainer = ({ children, className }) => {
  const { store } = useStore();
  const { uiStore } = store;
  const { openSellerInquiryModal } = uiStore;

  return (
    <S.ValuationContainer className={className}>
      {children}
      <S.Spacer />
      <S.InquiryPrompt>
        Questions about the StreetEasy Valuation?
      </S.InquiryPrompt>
      <S.InquiryTrigger onClick={openSellerInquiryModal}>
        Talk to us
      </S.InquiryTrigger>
      <S.ValuationFaq>
        or{" "}
        <S.ValuationFaqLink
          href="https://streeteasy.com/blog/streeteasy-valuation-faq/"
          rel="noopener noreferrer"
          target="_blank"
        >
          read the FAQ
        </S.ValuationFaqLink>
        .
      </S.ValuationFaq>
    </S.ValuationContainer>
  );
};

ValuationContainer.propTypes = {
  children: node.isRequired,
  className: string
};

ValuationContainer.defaultProps = {
  className: ""
};

export default ValuationContainer;
